import React from 'react';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  id?: string;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, label, disabled, id, className = '' }) => {
  return (
    <label
      className={`inline-flex items-center gap-2.5 cursor-pointer select-none group ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
      htmlFor={id}
    >
      <span className="relative flex-shrink-0">
        <input
          id={id}
          type="checkbox"
          className="sr-only"
          checked={checked}
          disabled={disabled}
          onChange={e => !disabled && onChange(e.target.checked)}
        />
        {/* Box */}
        <span
          className={`flex items-center justify-center w-[18px] h-[18px] rounded-[5px] border-2 transition-all duration-200
            ${checked
              ? 'bg-primary-600 border-primary-600 shadow-sm shadow-primary-200'
              : 'bg-white border-gray-300 group-hover:border-primary-400'
            }`}
        >
          {/* Animated checkmark SVG */}
          <svg
            viewBox="0 0 12 9"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`w-[9px] h-[9px] transition-all duration-200 ${checked ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}
          >
            <polyline points="1,5 4,8 11,1" />
          </svg>
        </span>
      </span>
      {label && (
        <span className={`text-sm font-medium transition-colors ${checked ? 'text-gray-900' : 'text-gray-600'}`}>
          {label}
        </span>
      )}
    </label>
  );
};

export default Checkbox;
